import React from 'react'

import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/utilities/ui'

type BlogArticleCardSkeletonProps = {
  className?: string
  imageAspectClassName?: string
}

const DEFAULT_SKELETON_IMAGE_ASPECT_CLASS_NAME = 'aspect-[520/264]'

export function BlogArticleCardSkeleton({
  className,
  imageAspectClassName = DEFAULT_SKELETON_IMAGE_ASPECT_CLASS_NAME,
}: BlogArticleCardSkeletonProps) {
  return (
    <li className={cn('h-full', className)}>
      <article
        aria-hidden
        className="flex h-full flex-col overflow-hidden rounded-[22px] border-[1.5px] border-black/10 bg-white/70"
      >
        <div className="flex flex-1 flex-col gap-4 p-3">
          <Skeleton className={cn(imageAspectClassName, 'w-full rounded-[10px]')} />

          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-[1.625rem] w-24 rounded-full" />
            <Skeleton className="h-[1.625rem] w-20 rounded-full" />
          </div>

          <div className="flex flex-1 flex-col gap-4">
            <Skeleton className="h-8 w-full rounded-lg" />
            <Skeleton className="h-8 w-[85%] rounded-lg" />
            <Skeleton className="h-5 w-full rounded-md" />
            <Skeleton className="h-5 w-full rounded-md" />
            <Skeleton className="h-5 w-[70%] rounded-md" />
          </div>
        </div>
      </article>
    </li>
  )
}
